import { render, staticRenderFns } from "./indexClassify.vue?vue&type=template&id=67e3d7b6&scoped=true"
import script from "./indexClassify.vue?vue&type=script&lang=js"
export * from "./indexClassify.vue?vue&type=script&lang=js"
import style0 from "./indexClassify.vue?vue&type=style&index=0&id=67e3d7b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3d7b6",
  null
  
)

export default component.exports